import React from "react"
import style from "./Hero.module.scss"
import { Row, Col } from "react-flexbox-grid"

export default () => (
  <div className={`${style.container} ${style.faq}`}>
    <Row>
      <Col sm={12} md={12}>
        <h1>Your UpdateHub account explained</h1>
        <div className={style.bar}></div>
      </Col>
    </Row>
    <Row>
      <Col mdOffset={2} xs={12} md={4}>
        <h2>Activation Fee:</h2>
        <p>
          The Activation Fee will be charged in month that you activate your
          device. Supposing that on 15th day of the current month you active 100
          devices and on 20th day you active more 10 devices, your bill of the
          current month have the 110 devices in the Activation Fee. <br />
          <br />
          In case you disable one device and activate in the same month, it will
          be charged only one activate, all reactivations made after billing
          will be charged as a new activation.
        </p>
      </Col>
      <Col xs={12} md={4}>
        <h2>Monthly Device Fee:</h2>
        <p>The active device has a monthly fee charged.</p>
        <h2>Storage Fee:</h2>
        <p>
          In case an update package is sent for a device, a update fee is
          charged. The devices which did not fetch updates, do not has
          corresponding update fees charged.
        </p>
      </Col>
    </Row>
    <Row>
      <Col mdOffset={2} xs={12} md={4}>
        <h2>Update Fee:</h2>
        <p>
          The update packages that you use to do your rollouts are stored on
          UpdateHub servers. The Storage Fee is charged monthly based on amount
          of storage used (rounded to GB).
        </p>
      </Col>
      <Col xs={12} md={4}>
        <h2>Transfer Fee:</h2>
        <p>
          The Transfer Fee takes into account the amount of data transferred as
          part of your update packages being sent to devices, as through the use
          of rollouts.
        </p>
      </Col>
    </Row>
  </div>
)
